import React from 'react';
import { HelpCenterLvl_2_1 } from '../../utils/constant';
import HelpCenterTemplate from '../../components/HelpCenterComponents/HelpCenterTemplate';
import { PartnershipHeadings } from '../../components/data/data/HelpCenter/HelpCenterData';

const Partnership = () => {
  return (
    <HelpCenterTemplate
      pageTitle="Partnership"
      sectionTitle="Understanding Spatial Grid & Business Value"
      sectionDescription="Get started"
      articlesData={PartnershipHeadings}
      basePath="/help-center/partnership-articles"
      breadcrumbPath={{
        name: 'Partnership',
        path: '/help-center/partnership',
      }}
      searchPlaceholder="Search the Spatial Grid Help Center"
      showArticleCount={true}
      maxDisplayArticles={5}
      seeAllLink="/help-center/partnership-articles"
    />
  );
};

export default Partnership;
